export const SEARCH_PATIENTS = "SEARCH_PATIENTS";
export const SAVE_SEARCH_RESULT = "SAVE_SEARCH_RESULT";
export const UPDATE_SEARCH_LOADING_STATUS = "UPDATE_SEARCH_LOADING_STATUS";
